
import {Component, Vue} from 'vue-property-decorator';
import moment from "moment-mini";


@Component({components: {}})
export default class MonthDatePicker extends Vue {
    private month = '';
    private dateMenu = false;

    // private getStartEndDates(date: Date): { start: Date, end: Date } {
    //     const endDate = date.AddMonths(1).AddDays(-1);
    //     return {start: date, end: endDate};
    // }

    private get monthDisplay(): string {
        // ohne Auswahl leer lassen, sonst zeigt das Feld "Invalid date" statt des Platzhalters
        return this.month ? moment(this.month).format("MMMM YYYY") : '';
    }
    private getFormattedDate(date: Date, separator = "-"): string {
        if (date) {
            const dd = String(date.getDate()).padStart(2, '0');
            const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
            const yyyy = date.getFullYear();
            return yyyy + separator + mm + separator + dd;
        } else {
            return '';
        }
    }

    private get firstDayOfWeek(): number {
        return 1;
    }

    openOnChange() {
        // if (date) {
        //     this.setFormattedDate(date);
        // }
    }

    private monthChanged() {
        this.dateMenu = false;
        const date = new Date(this.month);
        console.log(date);
        const start = date;
        const end = new Date(start.getFullYear(), start.getMonth() + 1, 0);
        this.$emit("monthChanged", {start: start, end: end, title: this.monthDisplay});
    }

    constructor() {
        super();
    }

    mounted() {
        this.openOnChange();
    }

    //TODO: get calendar week - localisation

    private get maxDate(): string {
        return this.getFormattedDate(new Date());
    }

    private clearDateValue() {
       // this.$emit("monthChanged", {start: this.picker, end: this.picker});
        //this.$emit("input", this.weekRange[0]);
    }
}
